<div class="corporate-fullscreen-loader" *ngIf="showLoader"></div>